export default __webpack_public_path__ + "static/media/2014-IMcover.8c7a5adf.jpg";